export interface Env {
    VITE_MODE: string;
    VITE_REALM: string;
    VITE_AGS_URL: string;
    VITE_HUB_URL: string;
    VITE_OSS_URL: string;
    VITE_TRAINING_URL: string;
    VITE_KEYCLOAK_URL: string;
    VITE_CUSTOMER_CONTROL_URL: string;
    VITE_BASE_URL_PATH: string;
    VITE_RAYGUN_API_KEY: string;
}

export type BuildTimeEnv = Partial<Record<keyof Env, string>>;

function readRuntimeValue(runtimeConfig: unknown, key: keyof Env): string | undefined {
    if (typeof runtimeConfig !== 'object' || runtimeConfig === null) {
        return undefined;
    }

    const value: unknown = Reflect.get(runtimeConfig, key);

    return typeof value === 'string' && value !== '' ? value : undefined;
}

/**
 * Resolves each setting from the configuration the server injects into
 * index.html, then from the values Vite inlines at build time (local
 * development via `.env`), then from a default.
 */
export function resolveEnv(runtimeConfig: unknown, buildTimeEnv: BuildTimeEnv, origin: string): Env {
    const resolve = (key: keyof Env, fallback: string): string =>
        readRuntimeValue(runtimeConfig, key) || buildTimeEnv[key] || fallback;

    return {
        VITE_MODE: resolve('VITE_MODE', 'development'),
        VITE_REALM: resolve('VITE_REALM', 'default'),
        VITE_AGS_URL: resolve('VITE_AGS_URL', origin),
        VITE_HUB_URL: resolve('VITE_HUB_URL', origin),
        VITE_OSS_URL: resolve('VITE_OSS_URL', origin),
        VITE_TRAINING_URL: resolve('VITE_TRAINING_URL', ''),
        VITE_KEYCLOAK_URL: resolve('VITE_KEYCLOAK_URL', ''),
        VITE_CUSTOMER_CONTROL_URL: resolve('VITE_CUSTOMER_CONTROL_URL', ''),
        VITE_BASE_URL_PATH: resolve('VITE_BASE_URL_PATH', '/job-viewer'),
        VITE_RAYGUN_API_KEY: resolve('VITE_RAYGUN_API_KEY', ''),
    };
}
